




































import { Component } from "vue-property-decorator";
import DarkModal from "@service/components/modal/DarkModal.vue";
import SettingsForm from "@service/components/settings/SettingsForm.vue"
import OnboardingHeader from "./OnboardingHeader.vue";
import BounceSpinner from "@share/common/BounceSpinner.vue";
import Overlay from "@share/common/Overlay.vue";
import UserFormBaseOwn from "@service/components/user-form-base/user-form-base-own/UserFormBaseOwn.vue";
import { SettingsHelper } from "@service/helpers/settingsHelper";
import { detectMob } from "@common/mobileHelper";
import { SettingsViewPart } from "@service/components/settings/types/SettingsViewPart";

@Component({
    name: "OnboardingSettings",
    components: { DarkModal, SettingsForm, OnboardingHeader, BounceSpinner, Overlay }
})
export default class OnboardingSettings extends UserFormBaseOwn {

    get disabled() {
        return !this.isLoaded || !this.valid;
    }

    get steps() {
        return this.segmentData;
    }

    get isLastStep() {
        return this.currentStepIndex === (this.steps.length - 1)
    }

    get currentStepIndex() {
        return this.steps.findIndex(el => el.value === this.currentViewPart) ?? 0;
    }

    async mounted() {
        await this.loadData(true);
        this.helper = new SettingsHelper(this.$store);
    }

    get isMobile() {
        return detectMob()
    }

    get needValidateTags() {
        return this.currentViewPart === SettingsViewPart.interests
    }

    async nextStep() {
        if(!this.validate(this.needValidateTags)) { return; }
        this.isLoaded = false;
        await this.save();

        this.isLoaded = true;

        if(this.isLastStep) {
            this.$emit('finalize');
        } else {
            this.currentViewPart = this.steps[this.currentStepIndex + 1]?.value;
        }
    }
}
